import { useContext } from 'react';
import { AppNavigateContext } from './SDKProvider';
import type { AppNavigate } from './types';

export function useAppNavigate(): AppNavigate {
  const appNavigate = useContext(AppNavigateContext);
  if (!appNavigate) {
    throw new Error('useAppNavigate must be used within an <SDKProvider>');
  }
  return appNavigate;
}
